import { render, staticRenderFns } from "./listCustomers.vue?vue&type=template&id=6c133be4&scoped=true"
import script from "./listCustomers.vue?vue&type=script&lang=ts"
export * from "./listCustomers.vue?vue&type=script&lang=ts"
import style0 from "./listCustomers.vue?vue&type=style&index=0&id=6c133be4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c133be4",
  null
  
)

export default component.exports